import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/PreferredStoreButton/preferredStoreButton.container"
    ).then((module) => ({
        default: module.PreferredStoreButton
    }))
);
